import { useEffect, useState } from "react";

function StepsIndicator({ currentStep, steps }) {
  return (
    <div className="d-flex flex-nowrap gap-3 my-3">
      {steps.map((step, index) => {
        const isActive = currentStep === index;
        const isDone = currentStep > index;

        return (
          <div
            key={index}
            className={`flex-fill p-2 p-md-3 rounded-3 border ${
              isActive
                ? "border-success"
                : isDone
                  ? "border-dark"
                  : "border-secondary"
            }`}
            style={{
              background: isActive ? "#f0fff1" : isDone ? "#d1dbef" : "#f0f0f0",
              transition: "all 0.3s ease",
            }}
          >
            <div className="d-flex flex-column flex-md-row align-items-center gap-2 m-0 mb-md-1">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: "28px",
                  height: "28px",
                  fontSize: "0.85rem",
                  background: isDone
                    ? "#283754"
                    : isActive
                      ? "#55cd70"
                      : "#ccc",
                  color: "white",
                  scale: "0.75",
                }}
              >
                {index + 1}
              </div>
              <span
                style={{
                  fontWeight: isActive ? "600" : "500",
                  color: isActive ? "#55cd70" : "#283754",
                }}
              >
                Step {index + 1}
              </span>
            </div>

            <p
              className="m-0 d-none d-md-block"
              style={{
                fontSize: "0.9rem",
                lineHeight: "1.3rem",
                color: isActive ? "#55cd70" : isDone ? "#283754" : "#999",
                fontWeight: isActive ? "600" : "500",
              }}
            >
              {step}
            </p>
          </div>
        );
      })}
    </div>
  );
}

export default StepsIndicator;
